import { ANIMALS } from 'constants';

export default function getAnimalObject(key) {
  return ANIMALS.filter(a => a.key === key)[0];
}



/** WEBPACK FOOTER **
 ** ./src/lib/getAnimalObject.js
 **/